import Vue from "vue";
import VueRouter from "vue-router";

import AppLayout from "../layouts/AppLayout.vue";
import DashboardLayout from "../layouts/DashboardLayout.vue";
import PublicLayout from "../layouts/PublicLayout.vue";

import NProgress from "nprogress";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "*",
    redirect: "/login",
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/ForgotPassword.vue"),
  },
  {
    path: "/login",
    name: "login",
    // component: PublicLayout,
    redirect: () => {
      window.location.href = "https://mulheregestacao.com.br/";
    },
    // children: [
    //   {
    //     path: "",
    //     component: () =>
    //       import(/* webpackChunkName: "login" */ "../views/login/Login.vue"),
    //   },
    // ],
  },
  {
    path: "/reset",
    component: PublicLayout,
    children: [
      {
        path: "",
        component: () =>
          import(/* webpackChunkName: "reset" */ "../views/login/reset.vue"),
      },
    ],
  },
  {
    path: "/resend",
    component: AppLayout,
    children: [
      {
        path: "",
        component: () =>
          import(/* webpackChunkName: "resend" */ "../views/Resend.vue"),
      },
    ],
  },
  {
    path: "/create-password",
    component: PublicLayout,
    children: [
      {
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "createPassword" */ "../views/login/createPassword.vue"
          ),
      },
    ],
  },

  {
    path: "/register",
    component: AppLayout,
    children: [
      {
        path: "terms-and-privacy",
        name: "terms-and-privacy",
        component: () =>
          import(
            /* webpackChunkName: "privacy" */ "../components/TermsAndPrivacy_Modal.vue"
          ),
      },
      {
        path: "terms",
        name: "terms",
        component: () =>
          import(
            /* webpackChunkName: "terms" */ "../components/Terms_Modal.vue"
          ),
      },
      {
        path: "",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/InitialSteps.vue"),
      },
      {
        path: "steps/:pharmacy?",
        name: "steps",
        component: () =>
          import(/* webpackChunkName: "steps" */ "../views/HomeView.vue"),
      },
      {
        path: "validating/:auto?",
        name: "validating",
        component: () =>
          import(
            /* webpackChunkName: "validating" */ "../views/ValidatingView.vue"
          ),
      },
    ],
  },
  {
    path: "/app",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "dashboard-home",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "../views/dashboard/home.vue"
          ),
      },
      {
        path: "pregnancy-data",
        name: "pregnancy-data",
        component: () =>
          import(
            /* webpackChunkName: "pregnancy" */ "../views/dashboard/pregnancy-data.vue"
          ),
      },
      {
        path: "antenatal",
        name: "antenatal",
        component: () =>
          import(
            /* webpackChunkName: "antenatal" */ "../views/dashboard/antenatal.vue"
          ),
      },
      {
        path: "antenatal-consult",
        name: "antenatal-consult",
        component: () =>
          import(
            /* webpackChunkName: "consult" */ "../views/dashboard/antenatal-consult.vue"
          ),
      },
      {
        path: "antenatal-ultra",
        name: "antenatal-ultra",
        component: () =>
          import(
            /* webpackChunkName: "ultra" */ "../views/dashboard/antenatal-ultra.vue"
          ),
      },
      {
        path: "antenatal-exam",
        name: "antenatal-exam",
        component: () =>
          import(
            /* webpackChunkName: "exam" */ "../views/dashboard/antenatal-exam.vue"
          ),
      },
      {
        path: "antenatal-vaccine",
        name: "antenatal-vaccine",
        component: () =>
          import(
            /* webpackChunkName: "vaccine" */ "../views/dashboard/antenatal-vaccine.vue"
          ),
      },
      {
        path: "antenatal-medication",
        name: "antenatal-medication",
        component: () =>
          import(
            /* webpackChunkName: "medication" */ "../views/dashboard/antenatal-medication.vue"
          ),
      },
      {
        path: "healthy-habits",
        name: "healthy-habits-home",
        component: () =>
          import(
            /* webpackChunkName: "healthy-habits" */ "../views/healthy-habits/home.vue"
          ),
      },
      {
        path: "healthy-habits/schedule",
        name: "healthy-habits-schedule",
        component: () =>
          import(
            /* webpackChunkName: "healthy-habits-schedule" */ "../views/healthy-habits/schedule.vue"
          ),
      },
      {
        path: "healthy-habits/reschedule",
        name: "healthy-habits-reschedule",
        component: () =>
          import(
            /* webpackChunkName: "healthy-habits-reschedule" */ "../views/healthy-habits/schedule.vue"
          ),
      },
      {
        path: "my-data",
        name: "my-data",
        component: () =>
          import(/* webpackChunkName: "my-data" */ "../views/MyData.vue"),
      },
      {
        path: "terms-and-privacy",
        name: "terms-and-privacy",
        component: () =>
          import(
            /* webpackChunkName: "privacy" */ "../components/TermsAndPrivacy.vue"
          ),
      },
      {
        path: "terms",
        name: "terms",
        component: () =>
          import(/* webpackChunkName: "terms" */ "../components/Terms.vue"),
      },
      {
        path: "change-password",
        name: "change-password",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "../views/ChangePassword.vue"
          ),
      },
      {
        path: "new-cupom",
        name: "new-cupom",
        component: () =>
          import(/* webpackChunkName: "new-cupom" */ "../views/NewCupom.vue"),
      },
    ],
  },
  {
    path: "/antenatal-print",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/PrenatalPrint.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
